import styled from 'styled-components';

export const Placeholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const PlaceholderContent = styled.div`
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    color: ${p => p.theme.colorGrey};
    line-height: 1.5;
    margin: 44px auto 0;
    max-width: 18.75em;
    text-align: center;
  }

  a {
    margin: 20px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Placeholder/index.tsx